module.exports = __webpack_public_path__ + "img/印象丽江3_1.45997511.jpg";